export const USER_ROLE_STUDENT = 3;
export const USER_ROLE_TEACHER = 4;
export const USER_ROLE_ADMIN = 5;
